import React from 'react';
import { PackageIcon, TargetIcon, UsersIcon, BellIcon, DatabaseIcon, BarChart2Icon, ArrowUpRightIcon } from 'lucide-react';
export const ServicesSection = () => {
  const services = [{
    icon: <PackageIcon size={28} data-id="element-486" />,
    title: 'Sponsorship Strategy & Packaging',
    description: 'Develop compelling sponsorship packages that maximize value for both sponsors and your event.',
    features: ['Market analysis & benchmarking', 'Value proposition development', 'Tiered package creation']
  }, {
    icon: <TargetIcon size={28} data-id="element-487" />,
    title: 'Targeted Prospecting & ABM',
    description: 'Identify and engage ideal sponsors through sophisticated targeting and account-based marketing.',
    features: ['Sponsor persona development', 'Predictive sponsor modeling', 'Multi-touch outreach campaigns']
  }, {
    icon: <UsersIcon size={28} data-id="element-488" />,
    title: 'Relationship-Driven Sales',
    description: 'Build meaningful connections with sponsors through consultative selling and relationship management.',
    features: ['Consultative sales approach', 'Negotiation & proposal management', 'Long-term relationship building']
  }, {
    icon: <BellIcon size={28} data-id="element-489" />,
    title: 'Multi-Channel Marketing',
    description: 'Engage potential sponsors through sophisticated, coordinated outreach across multiple channels.',
    features: ['LinkedIn & social selling', 'Email nurture sequences', 'Direct outreach & follow-up']
  }];
  return <section id="services" className="py-16 md:py-24 bg-white" data-id="element-490">
      <div className="container mx-auto px-6" data-id="element-491">
        <div className="mb-5" data-id="element-492">
          <span className="text-[#1B2A4A] font-medium inline-flex items-center gap-2 bg-[#f5f5f5] px-4 py-1.5 rounded-full shadow-sm" data-id="element-493">
            <div className="w-6 h-6 bg-[#B87333] rounded-sm" data-id="element-494"></div>
            Our services
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 mb-12 md:mb-20 items-center" data-id="element-495">
          <div data-id="element-496">
            <h2 className="text-3xl md:text-5xl font-bold text-[#1B2A4A] mb-6" data-id="element-497">
              Level up your sponsorship, improve{' '}
              <span className="font-serif italic text-[#B87333]" data-id="element-498">
                sales ROI
              </span>
            </h2>
            <p className="text-lg md:text-xl text-[#1B2A4A]/80 leading-relaxed" data-id="element-499">
              Better sponsorship leads to better marketing ROI. At Sales Source,
              we help you level up your complete sponsorship engine. From
              strategy to outreach, negotiation, and measurement.
            </p>
          </div>
          <div className="relative" data-id="element-500">
            <div className="absolute -top-6 -left-6 w-16 h-16 bg-[#B87333]/50 z-0 rounded-br-2xl" data-id="element-501"></div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sUs1gVj4HAdQnsEVx48Qu2/20230126_080712.jpg" alt="Conference venue setup" className="w-full h-auto object-cover rounded-lg shadow-md relative z-10" data-id="element-502" />
          </div>
        </div>
        {/* Main service with image */}
        <div className="bg-[#f5f5f5] rounded-lg overflow-hidden shadow-lg mb-10 md:mb-16 border border-gray-100" data-id="element-503">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0" data-id="element-504">
            <div className="h-full min-h-[300px] md:min-h-0" data-id="element-505">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7Km97H1L7Y2skehVdXHy7m/Stroopwafel_stand.jpg" alt="Stroopwafel stand at conference" className="w-full h-full object-cover" data-id="element-506" />
            </div>
            <div className="p-6 md:p-10" data-id="element-507">
              <h3 className="text-2xl font-bold mb-5 text-[#1B2A4A]" data-id="element-508">
                Outsourced Sponsorship Sales
              </h3>
              <p className="text-[#1B2A4A]/70 mb-6 leading-relaxed" data-id="element-509">
                Our outsourced sponsorship sales service provides event
                organizers with a dedicated team of experts who handle the
                entire sponsorship acquisition process.
              </p>
              <p className="text-[#1B2A4A]/70 mb-8 leading-relaxed" data-id="element-510">
                We combine strategic insights, data-driven targeting, and
                relationship-building expertise to secure high-value sponsors
                aligned with your event's audience and objectives.
              </p>
              <a href="https://forms.gle/zspSVdBJ7eiHmqQj6" className="inline-flex items-center gap-2 bg-[#B87333] hover:bg-[#B87333]/90 text-[#1B2A4A] px-5 py-3 rounded-md transition-all w-fit shadow-md font-medium" data-id="element-511">
                Learn more <ArrowUpRightIcon size={18} data-id="element-512" />
              </a>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-513">
          {services.map((service, index) => <div key={index} className="bg-white p-6 md:p-8 rounded-lg shadow-md hover:shadow-lg transition-all border border-gray-100 h-full flex flex-col transform hover:-translate-y-1 duration-300" data-id="element-514">
              <div className="bg-[#B87333]/20 p-4 rounded-full w-fit mb-6" data-id="element-515">
                {service.icon}
              </div>
              <h3 className="text-2xl font-bold mb-4 text-[#1B2A4A]" data-id="element-516">
                {service.title}
              </h3>
              <p className="text-[#1B2A4A]/70 mb-6 leading-relaxed" data-id="element-517">
                {service.description}
              </p>
              <ul className="space-y-3 text-[#1B2A4A]/70 mt-auto mb-6" data-id="element-518">
                {service.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-519">
                    <span className="text-[#B87333] mr-2 font-bold" data-id="element-520">•</span>
                    <span data-id="element-521">{feature}</span>
                  </li>)}
              </ul>
              <a href="#contact" className="inline-flex items-center gap-2 text-[#B87333] font-medium hover:text-[#B87333]/80 transition-colors mt-auto" data-id="element-522">
                Learn more <ArrowUpRightIcon size={18} data-id="element-523" />
              </a>
            </div>)}
        </div>
      </div>
    </section>;
};